import { Box, Button, Container, GlobalStyles, Stack, Link as MuiLink, NoSsr, Portal } from "@mui/material";
import { DateTime } from "luxon";
import { useCallback } from "react";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import HeaderLink from "./HeaderNavigation";

const cookieConsentZIndex = 2147483647;
const zendeskWidgetSelector = [
  'iframe[src*="zdassets.com"]',
  'iframe[src*="zendesk.com"]',
  'iframe[title*="Zendesk"]',
  'iframe[aria-label*="Zendesk"]',
  'iframe[title*="Messaging"]',
  'iframe[aria-label*="Messaging"]',
  'iframe[title*="messaging"]',
  'iframe[aria-label*="messaging"]',
].join(',');

export default function CookieConsent() {
  const [t] = useTranslation('header')
  const [tR] = useTranslation('routes')
  const [cookies, setCookie] = useCookies(['cookieconsent_status'])

  const onAccept = useCallback(() => {
    setCookie('cookieconsent_status', 'dismiss', {
      path: '/',
      expires: DateTime.now().plus({years: 1}).toJSDate(),
    });
  }, [])

  if (cookies.cookieconsent_status === 'dismiss') {
    return null;
  }

  return <NoSsr>
    <Portal>
      <>
        <GlobalStyles
          styles={{
            [zendeskWidgetSelector]: {
              zIndex: `${cookieConsentZIndex - 1} !important`,
            },
          }}
        />
        <Box
          component="div"
          sx={{
            position: 'fixed',
            zIndex: cookieConsentZIndex,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: 'secondary.main',
            py: 2,
            color: '#fff',
          }}
        >
          <Container
            maxWidth="xl"
            sx={{
              px: {
                xs: 2,
                md: 3,
                lg: 4
              }
            }}
          >
            <Stack direction={{xs:'column', sm: 'row'}} spacing={2} justifyContent="space-between" alignItems="center">
              <Stack>
                {t('This website uses cookies to ensure you get the best experience.')}
                <Stack direction="row" spacing={2}>
                  <MuiLink component={HeaderLink} to={String(tR('/info/privacy-policy'))} reloadDocument>{t('Privacy policy')}</MuiLink>
                  <MuiLink component={HeaderLink} to={String(tR('/info/terms-of-service'))} reloadDocument>{t('Terms of Service')}</MuiLink>
                </Stack>
              </Stack>
              <Button
                color="primary"
                variant="contained"
                size="large"
                onClick={onAccept}
                sx={{
                  flexShrink: 0,
                }}
              >{t('Got it!')}</Button>
            </Stack>
          </Container>
        </Box>
      </>
    </Portal>
  </NoSsr>
}
